import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {isMobileOnly as isMobile, isTablet} from 'react-device-detect';
import {
  validatePhoneHandler,
  validateOtpCodeHandler,
  validateCustomerType,
  verifyPhone,
  displayRestrictedCodePopup,
  clearOtpForm,
  setSaleOtpStep,
  openModal,
  setOtpPopupData,
  setOtpIsLoading,
  setIsOtpStep2Validated,
} from '../cellcomAbroadBlockSlice';
import {getCustomerAbroadPackages} from '../Shared/abroadThunk';
import {createOtpLoginStep02, setRestrictedCodeError, setOtpError} from 'app/utilities/authentication/authenticationSlice';
import {getRecaptchaToken} from 'app/utilities/recaptcha/recaptcha';
import {lobbyTabsEnum, otpValidationPopupContent, popupReasonEnum, saleOTPSteps} from '../cellcomAbroadVariables';
import {Row, Col} from 'reactstrap';
import OtpVerifyPhoneComponent from './OtpVerifyPhoneComponent';
import OtpVerifyCodeComponent from './OtpVerifyCodeComponent';
import BtnRightSideText from '../../../Shared/Buttons/BtnRightSideText';
import PlaneLoader from '../../AbroadTicketBlock/PlaneLoader';
import {gtag4} from 'app/utilities/analytics/tracking';
import {otpOrigin, originProcess} from 'app/Components/Block/OTPLoginBlock/Assets/variables';

const OtpVerificationComponent = (props) => {

  useEffect(() => {
    return () => {
      props.setOtpError(null);
      props.clearOtpForm();
      props.setRestrictedCodeError(null);

    };
  }, []);

  const handleOTPVerifyPhoneValidate = () => {
    props.validatePhoneHandler({form: props.data.otpPhoneForm}).then(function (result) {
      if (result.payload.valid) {
        OtpVerifyPhone(false, true);
      }
    });
  };

  async function OtpVerifyPhone(isVoice, wiGAReport) {
    if (wiGAReport) {
      switch (props.data.activeLobbyTab) {
        case lobbyTabsEnum.PACKAGEEXISTS:
          break;
        case lobbyTabsEnum.BUSINESSACCOUNT:
          if (props.data.startedFromPackage) {
          } else {
            gtag4({
              event: 'CellcomAbroad_Step1_BusinessNumSendCodeButton',
              button: 'שליחת קוד אימות',
              step: '1',
              action: 'BusinessNumSendCodeButton',
              process_type: 'business',
              funnel_name: '1 - Lobby - Business',
            });
          }
          break;
        default:
          break;
      }
    }

    const captchaToken = await getRecaptchaToken('OtpVerifyPhonePage');
    if (captchaToken == undefined || captchaToken == null || captchaToken == '') {
      return;
    }
    await props.verifyPhone({
      phoneNumber: props.data.otpPhoneForm.phone,
      asVoice: isVoice,
      captchaToken: captchaToken,
      otpOrigin: otpOrigin.ABROAD,
      originProcess: originProcess.LOBBY,
    });
  }

  async function handleOTPVerifyCodeValidate() {
    switch (props.data.activeLobbyTab) {
      case lobbyTabsEnum.PACKAGEEXISTS:
        break;
      case lobbyTabsEnum.BUSINESSACCOUNT:
        if (props.data.startedFromPackage) {
        } else {
          gtag4({
            event: 'CellcomAbroad_Step2_InsertCodeContinueButton',
            button: 'המשך',
            step: '2',
            action: 'InsertCodeContinueButton',
            process_type: 'business',
            funnel_name: '1 - Lobby - Business',
          });
        }
        break;
      default:
        break;
    }

    props.validateOtpCodeHandler({form: props.data.otpCodeForm}).then(function (result) {
      if (result.payload.valid) {
        submitOtpCode();
      }
    });
  }

  async function submitOtpCode() {
    props.setOtpError(null);
    props.setRestrictedCodeError(null);
    if (props.data.restrictedCodeRequired) {
      props.displayRestrictedCodePopup();
    } else {
      props.setOtpIsLoading(true);
      await props
        .createOtpLoginStep02({
          phoneNumber: props.data.otpData.otpPhone,
          otpCode: props.data.otpCodeForm.verifyCode,
          guid: props.data.otpData.step1Ticket,
          otpOrigin: otpOrigin.ABROAD,
          originProcess: originProcess.LOBBY,
        })
        .then((result) => {
          props.setOtpIsLoading(false);
          if (!result.payload.isSuccess) {
            switch (result.payload.codeError) {
              case '39':
                props.setOtpPopupData(otpValidationPopupContent.isNotCellcomAccount);
                props.openModal(popupReasonEnum.OTP_RESULT);
                break;
              case '1003':
                props.removeOtpData();
                props.setOtpError('קוד שקיבלתם כבר לא בתוקף. כדי לשמור על הפרטים שלכם, נתחיל את התהליך מחדש');
                break;
              case '750':
                props.setOtpError('לא ניתן להתקדם לרכישה, יש לפנות לשירות לקוחות ב- *'+ window.Config.technicalSupportPhone);
                break;
            }
          } else if (result.payload.isSuccess) {
            props.setIsOtpStep2Validated(true);
          }
        });
    }
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

  return (
    <div className='otp-verification-component'>
      {props.data.otpIsLoading && (
        <div className='otp-loader-wrapper'>
          <PlaneLoader />
        </div>
      )}
      <form noValidate id='cellcom-abroad-otp' onSubmit={handleSubmit}>
        <Row
          className={`h-100 ${
            (isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution) && !props.data.otpData.step1Ticket
              ? 'mobile-verify-phone'
              : ''
          }`}>
          <Col
            className={`${
              isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution
                ? 'col-12 mobile-verify-phone-container'
                : !props.data.otpData.step1Ticket
                ? 'col-6'
                : 'col-10'
            }`}>
            {!props.data.otpData.step1Ticket ? (
              <OtpVerifyPhoneComponent />
            ) : (
              <OtpVerifyCodeComponent otpVerifyPhone={(isVoice) => OtpVerifyPhone(isVoice)} />
            )}
          </Col>
          <Col
            className={`${
              isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution
                ? 'col-12'
                : !props.data.otpData.step1Ticket
                ? 'col-6 phone-validation-button'
                : 'col-2'
            } d-flex flex-wrap align-items-center lobby-otp-verification-button`}>
            <BtnRightSideText
              onclick={() => (!props.data.otpData.step1Ticket ? handleOTPVerifyPhoneValidate() : handleOTPVerifyCodeValidate())}
              isDisplayArrows={true}
              text={!props.data.otpData.step1Ticket ? 'שליחת קוד אימות' : 'המשך'}
              isBusiness={props.data.activeLobbyTab == lobbyTabsEnum.BUSINESSACCOUNT}
            />
          </Col>
        </Row>
      </form>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.cellcomAbroad,
  };
};

const mapDispatchToProps = {
  validatePhoneHandler,
  validateOtpCodeHandler,
  verifyPhone,
  validateCustomerType,
  getCustomerAbroadPackages,
  createOtpLoginStep02,
  displayRestrictedCodePopup,
  setRestrictedCodeError,
  setOtpError,
  clearOtpForm,
  setSaleOtpStep,
  openModal,
  setOtpPopupData,
  setOtpIsLoading,
  setIsOtpStep2Validated,
};

export default connect(mapStateToProps, mapDispatchToProps)(OtpVerificationComponent);
